import { useSoyuzData } from '@spotahome/soyuz/client';
import { ThemeProvider, UserInfoProvider } from '@spotahome/ui-library';

import RefereeContainer from './RefereeContainer';
import RefereeContainerRevamp from './RefereeContainerRevamp';

const RefereePage = () => {
  const { [RefereePage.NAME]: requestedData } = useSoyuzData();
  const { loggedIn, deviceType, deviceViewType } = requestedData;

  const isRedesign = deviceType === 'desktop';

  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <UserInfoProvider>
        {isRedesign ? (
          <RefereeContainerRevamp
            loggedIn={loggedIn}
            deviceViewType={deviceViewType}
          />
        ) : (
          <RefereeContainer
            loggedIn={loggedIn}
            deviceViewType={deviceViewType}
          />
        )}
        ;
      </UserInfoProvider>
    </ThemeProvider>
  );
};

RefereePage.NAME = 'RefereePageName';

RefereePage.requestData = req => ({
  data: {
    loggedIn: !!req.getAccessToken(),
    deviceType: req.device.type,
    deviceViewType: req.device.viewType
  }
});

export default RefereePage;
